import { api } from '@/lib/api/client'
import type { Board } from '@/types/work'

export async function fetchBoard(projectKey: string): Promise<Board> {
  const { data } = await api.get<{ data: Board }>(`/projects/${projectKey}/board`)

  return data.data
}
